<div class="overlay-box" id="outline-popup-box" (click)="closePopup($event)">
  <div class="overlay-box__container">
    <ng-container #dynamicComponent></ng-container>
  </div>
</div>

